export const ASSIGNMENTS_KEY = 'call_assignments';

export function getAssignments() {
  const raw = window.localStorage.getItem(ASSIGNMENTS_KEY);
  try {
    return raw ? JSON.parse(raw) : {};
  } catch {
    return {};
  }
}

export function setAssignment(callId, user) {
  const assignments = getAssignments();
  if (user) {
    assignments[callId] = user;
  } else {
    delete assignments[callId];
  }
  window.localStorage.setItem(ASSIGNMENTS_KEY, JSON.stringify(assignments));
}

export function getAssignmentsForUser(user) {
  const assignments = getAssignments();
  return Object.entries(assignments)
    .filter(([, u]) => u === user)
    .map(([id]) => id);
}
